import React, { useEffect } from "react";
import { useDispatch } from "react-redux";
import { fetchRestaurantFooter } from "../../actions/footerActions";

import {
  useSelector,
} from "react-redux";

import {
  useNavigate,
  useParams,
} from "react-router-dom";

import "./css/Footer.css";


function Footer() {

  const navigate =
    useNavigate();
  const dispatch = useDispatch();

  const {
    restaurantId,
    tableId,
  } = useParams();


  // ==========================================================
  // RESTAURANT DATA FROM BACKEND
  // ==========================================================

  const {
    restaurantName,
    mobile,
    email,
    address,
  } = useSelector(
    (state) => state.theme
  );


  const footerData = useSelector((state) => state.footer?.data || {});
  useEffect(() => {
    if (restaurantId) dispatch(fetchRestaurantFooter(restaurantId)).catch(() => {});
  }, [dispatch, restaurantId]);
  const footerName = footerData.restaurant_name || restaurantName;
  const footerPhone = footerData.phone || mobile;
  const footerEmail = footerData.email || email;
  const footerAddress = footerData.address || address;

  // ==========================================================
  // HOME
  // ==========================================================

  const goHome = () => {

    navigate(
      `/${restaurantId}/table/${tableId}`
    );

  };


  // ==========================================================
  // SCROLL TO SECTION
  // ==========================================================

  const scrollToSection = (
    sectionId
  ) => {

    const homePath =
      `/${restaurantId}/table/${tableId}`;


    const currentPath =
      window.location.pathname;


    if (
      currentPath === homePath
    ) {

      const section =
        document.getElementById(
          sectionId
        );


      if (section) {

        section.scrollIntoView({
          behavior: "smooth",
          block: "start",
        });

      }

      return;

    }


    navigate(
      `${homePath}#${sectionId}`
    );

  };


  // ==========================================================
  // CART
  // ==========================================================

  const goToCart = () => {

    navigate(
      `/${restaurantId}/table/${tableId}/cart`
    );

  };


  // ==========================================================
  // CURRENT YEAR
  // ==========================================================

  const year =
    new Date().getFullYear();


  return (

    <footer
      id="contact"
      className="theme4-footer"
    >


      {/* =====================================================
          GOLD LINE
      ===================================================== */}

      <div className="theme4-footer-gold-line">
      </div>


      <div className="theme4-footer-container">


        {/* ===================================================
            BRAND
        =================================================== */}

        <div className="theme4-footer-brand">

          <button
            type="button"
            className="theme4-footer-logo"
            onClick={goHome}
          >

            <span className="theme4-footer-logo-symbol">
              M
            </span>

            <span className="theme4-footer-logo-divider">
            </span>

            <span className="theme4-footer-logo-name">

              <strong>
                {footerName ||
                  "RESTAURANT"}
              </strong>

              <small>
                FINE DINING
              </small>

            </span>

          </button>


          <p>

            An intimate dining experience
            shaped by exceptional ingredients,
            thoughtful technique and timeless
            hospitality.

          </p>


          <button
            type="button"
            className="theme4-footer-order-button"
            onClick={goToCart}
          >

            VIEW YOUR ORDER

            <span>
              →
            </span>

          </button>

        </div>


        {/* ===================================================
            EXPLORE
        =================================================== */}

        <div className="theme4-footer-column">

          <span className="theme4-footer-heading">
            EXPLORE
          </span>


          <button
            type="button"
            onClick={goHome}
          >
            HOME
          </button>


          <button
            type="button"
            onClick={() =>
              scrollToSection(
                "story"
              )
            }
          >
            OUR STORY
          </button>


          <button
            type="button"
            onClick={() =>
              scrollToSection(
                "menu"
              )
            }
          >
            MENU
          </button>


          <button
            type="button"
            onClick={() =>
              scrollToSection(
                "ambiance"
              )
            }
          >
            AMBIANCE
          </button>


          <button
            type="button"
            onClick={() =>
              scrollToSection(
                "gallery"
              )
            }
          >
            GALLERY
          </button>


          <button
            type="button"
            onClick={() =>
              scrollToSection(
                "events"
              )
            }
          >
            PRIVATE EVENTS
          </button>


          <button
            type="button"
            onClick={() =>
              scrollToSection(
                "visit"
              )
            }
          >
            VISIT US
          </button>

        </div>


        {/* ===================================================
            VISIT
        =================================================== */}

        <div className="theme4-footer-column">

          <span className="theme4-footer-heading">
            VISIT
          </span>


          <p className="theme4-footer-footerAddress">

            {footerAddress ||
              "Restaurant footerAddress"}

          </p>


          {footerPhone && (

            <a
              href={`tel:${footerPhone}`}
              className="theme4-footer-contact-link"
            >

              {footerPhone}

            </a>

          )}


          {footerEmail && (

            <a
              href={`mailto:${footerEmail}`}
              className="theme4-footer-contact-link"
            >

              {footerEmail}

            </a>

          )}

        </div>


        {/* ===================================================
            CONTACT
        =================================================== */}

        <div className="theme4-footer-column">

          <span className="theme4-footer-heading">
            CONTACT
          </span>


          <p>

            For private dining,
            celebrations and special
            occasions, please contact
            our team.

          </p>


          {footerPhone && (

            <a
              href={`tel:${footerPhone}`}
              className="theme4-footer-gold-link"
            >

              CALL US

              <span>
                →
              </span>

            </a>

          )}


          {footerEmail && (

            <a
              href={`mailto:${footerEmail}`}
              className="theme4-footer-gold-link"
            >

              EMAIL US

              <span>
                →
              </span>

            </a>

          )}

        </div>


      </div>


      {/* =====================================================
          LARGE BRAND
      ===================================================== */}

      <div className="theme4-footer-monogram">

        <span>
          M
        </span>

        <strong>
          {footerName ||
            "RESTAURANT"}
        </strong>

      </div>


      {/* =====================================================
          BOTTOM
      ===================================================== */}

      <div className="theme4-footer-bottom">

        <div>

          © {year}{" "}

          {footerName ||
            "Restaurant"}.

          {" "}
          All rights reserved.

        </div>


        <button
          type="button"
          onClick={() =>
            window.scrollTo({
              top: 0,
              behavior: "smooth",
            })
          }
        >

          BACK TO TOP

          <span>
            ↑
          </span>

        </button>

      </div>

      <p className="theme4-footer-disclaimer">{footerData.disclaimer || "Food images are for presentation purposes only. Actual items may vary."}</p>
    
      {/* Restaurant social profiles (only show configured HTTPS/HTTP URLs) */}
      {[
        { field: "facebook_url", label: "Facebook", glyph: "f" },
        { field: "instagram_url", label: "Instagram", glyph: "◎" },
        { field: "youtube_url", label: "YouTube", glyph: "▶" },
        { field: "whatsapp_url", label: "WhatsApp", glyph: "◉" },
      ].some(({ field }) => /^https?:\/\//i.test((footerData?.[field] || "").trim())) && (
        <nav aria-label="Restaurant social media" style={{ display: "flex", flexWrap: "wrap", justifyContent: "center", alignItems: "center", gap: "14px", padding: "14px 18px" }}>
          {[
            { field: "facebook_url", label: "Facebook", glyph: "f" },
            { field: "instagram_url", label: "Instagram", glyph: "◎" },
            { field: "youtube_url", label: "YouTube", glyph: "▶" },
            { field: "whatsapp_url", label: "WhatsApp", glyph: "◉" },
          ].filter(({ field }) => /^https?:\/\//i.test((footerData?.[field] || "").trim())).map(({ field, label, glyph }) => (
            <a key={field} href={footerData[field].trim()} target="_blank" rel="noopener noreferrer" aria-label={label} title={label}
               style={{ display: "inline-flex", alignItems: "center", justifyContent: "center", minWidth: "32px", minHeight: "32px", color: "inherit", textDecoration: "none", fontWeight: 700, fontSize: "20px" }}>
              {glyph}
            </a>
          ))}
        </nav>
      )}
    </footer>

  );
}


export default Footer;